<p-progressSpinner *ngIf="loadingData" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
<div *ngIf="roles">
    <p><strong>Role ID:</strong> {{ roles.id }}</p>
    <p><strong>Name:</strong> {{ roles.name }}</p>
    <p><strong>description:</strong> {{ roles.description }}</p>
</div>